module.exports = __webpack_public_path__ + "static/media/EC.c94fac98.png";